import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { each } from 'lodash'
gsap.registerPlugin(ScrollTrigger);

import { app } from '../../utils/store';

export default class Forms {
    constructor() {
        this.input = {
            all: document.querySelectorAll('input:not([type="checkbox"]), textarea'),
            file: document.querySelectorAll('input[type="file"]'),
            select: document.querySelectorAll('input[type="select"]'),
            choice: document.querySelector('.wpcf7-form.landing select[name="job"]'),
            container: document.querySelectorAll('.input-container input:not([type="checkbox"]), .input-container textarea'),
        };

        this.form = {
            login_short: document.getElementById('loginform'),
            checkout: document.querySelector('form.checkout'),
            edit_address: document.querySelector('form.edit-address'),
            rating: document.querySelector('.form-rating'),
            cf7: document.querySelectorAll('.wpcf7-form'),
            cf7_nation: document.querySelector('.wpcf7-select.country_auto'),

        }
        this.modal = {
            slides: document.getElementById('slides-modal'),
            streaming: document.getElementById('streaming-modal'),
            video: document.getElementById('video-modal'),
            file: document.querySelectorAll('[id*="file-modal-"]'),
        }

        this.fields = document.querySelector('form .fields');
        this.topics = document.getElementById('select-topics');

        this.header = document.querySelector('header');
        this.body = document.querySelector('body');

        this.locale = {
            send: {
                it: 'Inviando...',
                en: 'Sending...',
                fr: 'Envoi...',
                de: 'Ich schicke...',
                ru: 'Посылаю...',
            },
            sent: {
                it: 'Inviato',
                en: 'Sent',
                fr: 'Envoyé',
                de: 'Gesendet',
                ru: 'Отправлено',
            },
        }

        this.validation();
        if (this.input.choice) {
            this.cf7Conditions(this.input.choice);
        }

        if (this.form.cf7_nation) {
            this.stateSelection();
        }

        this.onSubmit()

    }

    validation = () => {
        this.input.file.forEach((input) => {
            input.addEventListener('change', () => {
                var file = input.value;
                if (!file) {
                    input.parentNode.classList.remove('valid');
                    input.classList.remove('valid');
                } else {
                    input.parentNode.classList.add('valid');
                    input.classList.add('valid');
                }
            });
        });
    }

    stateSelection = () => {

        var province_field = document.querySelector('.input-container.province');
        var province_field_select = document.querySelector('.input-container.province select');
        var provinceFree_field = document.querySelector('.input-container.province-free');
        var provinceFree_input = document.querySelector('.input-container.province-free input');
        var hidden_province = document.querySelector('input[type="hidden"][name="province-free"]');
        console.log(hidden_province, province_field_select, provinceFree_input);
        this.form.cf7_nation.addEventListener('change', () => {

            if (this.form.cf7_nation.value == 'Italy') {

                province_field.classList.remove('d-none');
                provinceFree_input.classList.remove('wpcf7-form-control');
                provinceFree_input.classList.remove('wpcf7-validates-as-required');
                // province_field_select.classList.add('wpcf7-validates-as-required');

                // provinceFree_input.classList.remove('wpcf7-validates-as-required ');
                // provinceFree_input.classList.remove('wpcf7-not-valid');
                provinceFree_field.classList.add('d-none');

                provinceFree_input.removeAttribute('required');
                hidden_province.value = "";
                provinceFree_input.value = "";

            } else {
                provinceFree_field.classList.remove('d-none');
                province_field.classList.add('d-none');
                provinceFree_input.classList.add('wpcf7-form-control');
                provinceFree_input.classList.add('wpcf7-validates-as-required');
                provinceFree_input.setAttribute('required', true);
                hidden_province.value = "";

            }
        });
        provinceFree_input.addEventListener('input', (e) => {
            hidden_province.value = e.target.value;
        });
        province_field_select.addEventListener('change', (e) => {
            hidden_province.value = e.target.value;
        });

    }

    cf7Conditions = (input) => {

        input.addEventListener('change', (e) => {
            var choice = e.target.value;
            console.log(choice)
            if (choice == 'Retailer') {
                console.log('è retailer')
                selectOption(this.input.choice.options[4])
                if (document.querySelector('.input-container.n-shop')) {
                    document.querySelector('.input-container.n-shop').classList.remove('d-none');
                }
            } else {
                if (document.querySelector('.input-container.n-shop')) {
                    document.querySelector('.input-container.n-shop').classList.add('d-none');
                }
            }
        })

        function selectOption(option) {
            console.log(option.parentNode)
            each(option.parentNode.options, (el) => {
                el.removeAttribute('selected');
            })
            option.setAttribute('selected', 'selected');
        }
    }

    manipulate = () => {
        // Moving the label inside the control <span class="wpcf7-form-control-wrap">
        if (this.form.cf7[0]) {
            this.form.cf7.forEach((form) => {
                form.querySelectorAll('.input-container label').forEach((label) => {
                    label.parentNode.querySelector('.wpcf7-form-control-wrap').append(label);
                });
            });
        }

        if (this.form.login_short) {
            let fields = ['.login-username', '.login-password'];
            this.form.login_short.querySelectorAll(fields).forEach((field) => {
                field.classList.add('input-container');

                var label = field.querySelector('label');
                // console.log(label)
                label.parentNode.append(label);

                field.querySelector('input').placeholder = field.querySelector('label').innerHTML;
            });

            // UI Fixes to Remeber me
            var content = document.createElement('span');
            content.classList.add('label');

            var small = document.createElement('small');
            small.innerHTML = 'Ricordami';
            content.append(small);

            this.form.login_short.querySelector('.login-remember label').innerHTML = this.form.login_short.querySelector('.login-remember input').outerHTML;
            this.form.login_short.querySelector('.login-remember label').append(content);
        }

        if (this.form.register) {

            this.form.register.querySelectorAll('form.register .afreg_half_field').forEach((field) => {
                field.classList.remove('form-row');
                field.classList.add('col-12');
                field.classList.add('col-sm-6');
                field.classList.add('input-container');

                var label = field.querySelector('label');
                // console.log(label.parentNode)
                label.parentNode.append(label);
            });

            this.form.register.querySelectorAll('form.register .afreg_full_field').forEach((field) => {
                field.classList.remove('form-row');
                field.classList.add('col-12');
                field.classList.add('input-container');

                var label = field.querySelector('label');
                console.log(label.parentNode)
                label.parentNode.append(label);
            });

            this.form.register.querySelectorAll('form.register .afreg_extra_fields').forEach((fields) => {
                fields.classList.add('row');
                fields.querySelectorAll('p.newr').forEach((field) => {
                    field.classList.remove('form-row');
                    field.classList.add('col-12');

                    // UI Fixes to Display Checkboxes correct
                    var label = field.querySelector('label');
                    var span = label.querySelector('span.required');

                    span.innerHTML = span.parentNode.innerHTML;
                    span.querySelector('span').remove();
                    span.classList.remove('required');
                    span.classList.add('label');

                    var content = document.createElement('label');
                    field.append(content);
                    content.innerHTML = span.outerHTML;

                    var input = field.querySelector('input[type="checkbox"]');
                    content.prepend(input);

                    field.querySelector('label[for]').remove();
                });
            });
        }

        if (this.form.edit_account) {
            this.form.edit_account.querySelectorAll('.afreg_extra_fields')[0].remove();
            this.form.edit_account.querySelector('#afreg_nonce_field').remove();
        }

        if (this.form.edit_address) {
            this.form.edit_address.querySelectorAll('.fields-container p').forEach((field) => {
                field.classList.remove('form-row');
                field.classList.remove('form-row-first');
                field.classList.remove('form-row-last');
                field.classList.remove('form-row-wide');
                field.classList.add('col-12');
                field.classList.add('col-sm-6');
                field.classList.add('input-container');

                field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;

                if (field.id == 'shipping_company_field' || field.id == 'billing_company_field') {
                    field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;
                }
                if (field.id == 'shipping_address_2_field' || field.id == 'billing_address_2_field') {
                    field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;
                    field.querySelector('label').classList.remove('screen-reader-text');
                }

                var label = field.querySelector('label');
                // console.log(label.parentNode)
                label.parentNode.append(label);
            });

            this.form.edit_address.querySelectorAll('.fields-container p select').forEach((select) => {
                select.parentNode.querySelector('label').remove();
            });

            this.form.edit_address.querySelectorAll('input[placeholder]').forEach((input) => {
                var label = input.parentNode.querySelector('label');
                if (label) {

                    input.placeholder = label.innerHTML;
                    // console.log(input + ' ' + input.getAttribute('placeholder'));
                    console.log(input.placeholder)
                }
            });
        }

        if (this.form.checkout) {
            // Billing Form
            this.form.checkout.querySelector('.woocommerce-billing-fields__field-wrapper').classList.add('row');

            this.form.checkout.querySelectorAll('.woocommerce-billing-fields__field-wrapper p').forEach((field) => {
                field.classList.remove('form-row');
                field.classList.remove('form-row-first');
                field.classList.remove('form-row-last');
                field.classList.remove('form-row-wide');
                field.classList.add('col-12');
                field.classList.add('col-sm-6');
                field.classList.add('input-container');

                field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;

                if (field.id == 'billing_company_field') {
                    field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;
                }

                var label = field.querySelector('label');
                // console.log(label.parentNode)
                label.parentNode.append(label);
            });

            this.form.checkout.querySelectorAll('.woocommerce-billing-fields__field-wrapper p select').forEach((select) => {
                select.parentNode.querySelector('label').remove();
            });

            this.form.checkout.querySelectorAll('.woocommerce-billing-fields__field-wrapper input[placeholder]').forEach((input) => {
                var label = input.parentNode.querySelector('label');
                label.innerHTML = input.placeholder;
            });

            // Shipping Form
            if (this.form.checkout.querySelector('.woocommerce-shipping-fields__field-wrapper')) {
                var form_shipping = this.form.checkout.querySelector('.woocommerce-shipping-fields__field-wrapper');

                form_shipping.classList.add('row');

                form_shipping.querySelectorAll('p').forEach((field) => {
                    field.classList.remove('form-row');
                    field.classList.remove('form-row-first');
                    field.classList.remove('form-row-last');
                    field.classList.remove('form-row-wide');
                    field.classList.add('col-12');
                    field.classList.add('col-sm-6');
                    field.classList.add('input-container');

                    field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;

                    if (field.id == 'shipping_company_field') {
                        field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;
                    }
                    if (field.id == 'shipping_address_2_field') {
                        field.querySelector('span').outerHTML = field.querySelector('span').innerHTML;
                    }

                    var label = field.querySelector('label');
                    // console.log(label.parentNode)
                    label.parentNode.append(label);
                });

                form_shipping.querySelectorAll('.woocommerce-shipping-fields__field-wrapper p select').forEach((select) => {
                    select.parentNode.querySelector('label').remove();
                });

                form_shipping.querySelectorAll('input[placeholder]').forEach((input) => {
                    var label = input.parentNode.querySelector('label');
                    console.log(input)
                    label.innerHTML = input.placeholder;
                    // console.log(input + ' ' + input.getAttribute('placeholder'));
                    console.log(input.placeholder)
                });
            }
        }
    }

    onSubmit = () => {
        var disableSubmit = false,
            submit = document.querySelector('.wpcf7-submit[type="submit"]')

        var isButton = submit.tagName == 'BUTTON'
        var isInput = submit.tagName == 'INPUT'

        if (!submit) return

        if (isInput) {
            var initialString = submit.getAttribute('value')
        } else if (isButton) {
            var spanElement = submit.querySelector('span span')
            var initialString = spanElement ? spanElement.innerHTML : (submit.textContent || submit.innerText || '')
        }

        submit.addEventListener('click', (event) => {
            if (isInput) {
                var initialString = event.target.getAttribute('value')

                event.target.value = this.locale.send[app.language]
                event.target.setAttribute('value', this.locale.send[app.language])

            } else if (isButton) {
                var spanElement = event.target.querySelector('span span')
                var initialString = spanElement ? spanElement.innerHTML : (event.target.textContent || event.target.innerText || '')

                if (spanElement) {
                    each(event.target.querySelectorAll('span span'), (span) => {
                        span.innerHTML = this.locale.send[app.language]
                    })
                } else {
                    // Fallback: update button text directly if no span structure
                    event.target.textContent = this.locale.send[app.language]
                }
            }
            console.log(initialString)

            if (disableSubmit) {
                event.target.style.pointerEvents = 'all'
                return false
            } else {
                event.target.style.pointerEvents = 'none'
            }

            disableSubmit = true

            return true
        })

        // Event Listeners: applica a tutti i form CF7 (non solo il primo)
        var forms = document.querySelectorAll('.wpcf7-form')
        forms.forEach((form) => {
            form.addEventListener('wpcf7invalid', (event) => {
                if (isInput) {
                    submit.value = initialString
                    submit.setAttribute('value', initialString)
                } else if (isButton) {
                    var spans = submit.querySelectorAll('span span')
                    if (spans.length > 0) {
                        each(spans, (span) => {
                            span.innerHTML = initialString
                        })
                    } else if (initialString) {
                        submit.textContent = initialString
                    }
                }

                disableSubmit = false;
                submit.style.pointerEvents = 'all'
            }, false);

            form.addEventListener('wpcf7mailsent', (event) => {
                if (isInput) {
                    submit.value = initialString
                    submit.setAttribute('value', initialString)
                } else if (isButton) {
                    var spans = submit.querySelectorAll('span span')
                    if (spans.length > 0) {
                        each(spans, (span) => {
                            span.innerHTML = initialString
                        })
                    } else if (initialString) {
                        submit.textContent = initialString
                    }
                }

                disableSubmit = true;
                submit.style.pointerEvents = 'none'
            }, false);

            // Quando l'invio fallisce (es. mail in locale): ripristina bottone
            form.addEventListener('wpcf7mailfailed', (event) => {
                if (isInput) {
                    submit.value = initialString
                    submit.setAttribute('value', initialString)
                } else if (isButton) {
                    var spans = submit.querySelectorAll('span span')
                    if (spans.length > 0) {
                        each(spans, (span) => {
                            span.innerHTML = initialString
                        })
                    } else if (initialString) {
                        submit.textContent = initialString
                    }
                }

                disableSubmit = false;
                submit.style.pointerEvents = 'all'
            }, false);
        })

        // Listener wpcf7_before_send_mail: solo sul primo form (evento custom CF7, se usato)
        let formFirst = document.querySelector('.wpcf7[role="form"]')
        if (formFirst) {
            formFirst.addEventListener('wpcf7_before_send_mail', (event) => {
                if (isInput) {
                    event.target.value = this.locale.sent[app.language]
                    event.target.setAttribute('value', this.locale.sent[app.language])
                } else if (isButton) {
                    var spans = event.target.querySelectorAll('span span')
                    if (spans.length > 0) {
                        each(spans, (span) => {
                            span.innerHTML = this.locale.sent[app.language]
                        })
                    } else {
                        event.target.textContent = this.locale.sent[app.language]
                    }
                }

                disableSubmit = false
                submit.style.pointerEvents = 'none'
            }, false)
        }
    }

    set = () => {
        this.input.container.forEach((input) => {
            gsap.set(input, {
                y: 100,
                autoAlpha: 0,
            })
        });

    }

    animation = () => {
        this.input.container.forEach((input) => {
            gsap.to(input, {
                // duration: 2,
                y: 0,
                autoAlpha: 1,
                scrollTrigger: {
                    trigger: input,
                    start: 'top bottom-=100',
                    // end: 'bottom top',
                    scrub: false,
                }
            })
        });
    }
}
